import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  priceCut?: string;
  price?: string;
  classes?: {
    price?: string;
    priceCut?: string;
  };
  className?: string;
  expiresIn?: string;
}

const Pricing: FC<Props> = ({
  price,
  priceCut,
  classes,
  className,
  expiresIn,
}) => {
  const isCutPrice =
    priceCut && priceCut !== '/Month' && !priceCut.startsWith('/');

  return (
    <div>
      <div className={twMerge(`flex gap-2 mb-4 items-baseline`, className)}>
        <p className='text-grayZl-500 text-base font-semibold self-start'>₹</p>
        <p
          className={twMerge(
            `text-white text-[32px] leading-[40px] font-semibold`,
            classes?.price,
          )}
        >
          {price}
        </p>
        {priceCut && (
          <p
            className={twMerge(
              `${isCutPrice ? 'line-through text-white/50 xl:text-xl text-2xl' : 'text-white/60 text-2xl'} font-medium self-end`,
              classes?.priceCut,
            )}
          >
            {priceCut}
          </p>
        )}
      </div>
      <p className='mb-4 italic text-center text-success-400 xl:text-sm text-xs font-medium leading-[22px]'>
        {expiresIn}
      </p>
    </div>
  );
};

export default Pricing;
